export const game2LoadingMessages = [
    'Casting sheep for the role',
    'Building a fence',
    'Counting sheep',
    'Feeding the sheep',
    'Cutting the grass',
];

export const game2LoadedWaitingMessages = ['Finished loading. Waiting for fellow monsters to connect'];
